define('../src/js/rules',['require','exports','module','gameday-business-rules/gameday-business-rules'],function (require, exports, module) {
    var Rules = require("gameday-business-rules/gameday-business-rules");
    var config = {
        hideVideoUntilFinal         : false, 
        hideColorFeedSpringTraining : false
    };
    Rules.getInstance(config);
});
